import React from 'react';
import { connect } from 'react-redux';

import { getUserDistrictId, getIsLoggedIn } from 'State/selectors';

import { AccessPrompt } from './AccessPrompt';
import { closeAccessPrompt } from './state/actions';
import { getAccessPrompt } from './state/selectors';

class Manager extends React.Component {
  close = this.props.closeAccessPrompt;

  onUser = user => {
    const { accessPrompt } = this.props;
    const { closeOnUser, onUser } = accessPrompt;
    if (closeOnUser) {
      this.close();
    }
    onUser(user);
  };

  onError = e => {
    const { accessPrompt } = this.props;
    const { closeOnError, onError } = accessPrompt;
    if (closeOnError) {
      this.close();
    }
    onError(e);
  };

  render() {
    const { accessPrompt, districtId, isLoggedIn } = this.props;
    const { open, title } = accessPrompt;

    return (
      <AccessPrompt
        isLoggedIn={isLoggedIn}
        districtId={districtId}
        open={open}
        title={title}
        onUser={this.onUser}
        onCancel={this.close}
        onError={this.onError}
      />
    );
  }
}

const mapStateToProps = state => ({
  isLoggedIn: getIsLoggedIn(state),
  districtId: getUserDistrictId(state),
  accessPrompt: getAccessPrompt(state),
});

const mapDispatchToProps = {
  closeAccessPrompt,
};

const AccessPromptManager = connect(
  mapStateToProps,
  mapDispatchToProps
)(Manager);

export { AccessPromptManager };



// WEBPACK FOOTER //
// ./src/common/Components/AccessPrompt/AccessPromptManager.js